import { render, staticRenderFns } from "./UserLevels.vue?vue&type=template&id=132c8e65&scoped=true&"
import script from "./UserLevels.vue?vue&type=script&lang=js&"
export * from "./UserLevels.vue?vue&type=script&lang=js&"
import style0 from "./UserLevels.vue?vue&type=style&index=0&id=132c8e65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132c8e65",
  null
  
)

export default component.exports